import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { apis } from '@/modules/apiClients'
import { organizationsQueryKeys } from '@/storeHooks/useOrganizations'

export const useAdminOrganization = (id: string) => {
  const isCreateMode = id === 'new'

  const query = useQuery({
    queryKey: organizationsQueryKeys.detail(id),
    enabled: !!id && !isCreateMode,
    // Same key as useOrganization, so the cached value must keep the same
    // (full Axios response) shape or the two hooks corrupt each other's cache.
    queryFn: () => apis.partnerService.organizationsOrganizationIdGet(id),
    // Matches useOrganization; also keeps refetch-on-focus from reseeding the
    // detail form and discarding unsaved admin edits.
    staleTime: 5 * 60 * 1000,
  })

  const notFound =
    query.isError && (query.error as AxiosError)?.response?.status === 404

  return {
    organization: query.data?.data.data,
    isLoading: query.isPending && !isCreateMode,
    isError: query.isError && !notFound,
    notFound,
    refetch: query.refetch,
  }
}
